"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.customerTableConf = void 0;
var end2end_1 = require("@hudled/end2end");
var constants_1 = require("containers/TableMaker/constants");
var single_1 = require("utils/selectors/single");
var AccessDropdown_1 = __importDefault(require("./CellComponents/AccessDropdown"));
var Connection_1 = __importDefault(require("./CellComponents/Connection"));
var PricingPlan_1 = __importDefault(require("./CellComponents/PricingPlan"));
var Spend_1 = __importDefault(require("./CellComponents/Spend"));
var TotalCustomers_1 = __importDefault(require("./CellComponents/TotalCustomers"));
var TotalSpend_1 = __importDefault(require("./CellComponents/TotalSpend"));
var XL = constants_1.CellSize.XL, LG = constants_1.CellSize.LG, MD = constants_1.CellSize.MD, SM = constants_1.CellSize.SM, XS = constants_1.CellSize.XS;
exports.customerTableConf = {
    // header: { compactMargins: true },
    headersMap: {
        name: 'Customers',
        'totalLTMSaasSpendInFx.USD': 'Spend (1Y)',
        serviceStatsCount: 'Tools',
        planPricePerYear: 'Pricing Plan',
        employeeCount: 'Headcount',
        userCount: 'Users',
        createdAt: 'Join Date',
        ownerDisplayName: 'Owner',
        ownerEmail: '',
    },
    headerTooltip: {
        serviceStatsCount: { description: 'Total software tools a company is paying for' },
        'totalLTMSaasSpendInFx.USD': { description: 'Total software spend in the last year' },
        ownerDisplayName: { description: 'Primary point of contact in the company' },
        employeeCount: { description: 'Total employees in the company' },
        userCount: { description: 'Total users in the company' },
        connections: { description: 'Total integrated entities associated with the company' },
    },
    extractors: {
        ownerDisplayName: function (c) { var _a, _b; return c.ownerId && ((_b = (_a = c.ownerData) === null || _a === void 0 ? void 0 : _a[c.ownerId]) === null || _b === void 0 ? void 0 : _b.displayName); },
        ownerEmail: function (c) { var _a, _b; return c.ownerId && ((_b = (_a = c.ownerData) === null || _a === void 0 ? void 0 : _a[c.ownerId]) === null || _b === void 0 ? void 0 : _b.email); },
        serviceStatsCount: function (c) { var _a; return c.serviceStatsCount || ((_a = c.connectionIds) === null || _a === void 0 ? void 0 : _a.length) ? c.serviceStatsCount : undefined; },
        'totalLTMSaasSpendInFx.USD': function (c) { var _a, _b; return c.totalLTMSaasSpend || ((_a = c.connectionIds) === null || _a === void 0 ? void 0 : _a.length) ? (_b = c.totalLTMSaasSpendInFx) === null || _b === void 0 ? void 0 : _b.USD : undefined; },
    },
    cells: [
        {
            cell: { width: XL },
            avatar: { size: 'xxs' },
            truncate: {},
            field: 'name',
            footerAggregate: 'count',
            countInHeader: true,
            footerAggregateRenderValue: TotalCustomers_1.default,
            // ToDo: use cell component to handle override
        },
        {
            cell: { width: SM, textAlign: 'right' }, field: 'serviceStatsCount', footerAggregate: 'sum', fallback: '-',
        },
        {
            cell: { width: MD + XS, textAlign: 'right', offset: 'right' },
            money: { isRounded: true },
            field: 'totalLTMSaasSpendInFx.USD',
            renderComponent: Spend_1.default,
            footerAggregate: 'sum',
            footerAggregateRenderValue: TotalSpend_1.default,
            footerAggregateValueExtract: function (c, profile) {
                var _a, _b;
                var mainCompanyBaseCurrency = (profile && ((_a = (0, end2end_1.getMainCompanyData)(profile)) === null || _a === void 0 ? void 0 : _a.baseCurrency)) || 'AUD';
                return (mainCompanyBaseCurrency && ((_b = c.totalLTMSaasSpendInFx) === null || _b === void 0 ? void 0 : _b[mainCompanyBaseCurrency])) || 0;
            },
        },
        { cell: { width: XL, offset: 'left' }, truncate: {}, fields: ['ownerDisplayName', 'ownerEmail'] },
        { cell: { width: MD }, field: 'plan', renderComponent: PricingPlan_1.default },
        {
            cell: { width: MD, textAlign: 'right' }, field: 'employeeCount', footerAggregate: 'sum', fallback: '-',
        },
        {
            cell: { width: SM + XS, textAlign: 'right', offset: 'right' }, field: 'userCount', footerAggregate: 'sum',
        },
        {
            cell: { width: LG, textAlign: 'center' }, field: 'createdAt', defaultOrder: -1, renderField: end2end_1.getISODate,
        },
        { cell: { width: MD + XS, textAlign: 'right' }, field: 'connections', renderComponent: Connection_1.default },
        { cell: { width: SM, offset: 'left', isActionCell: true }, key: 'accessDropdown', renderComponent: AccessDropdown_1.default },
    ],
    footer: { footerSelector: single_1.selectProfile },
};
